module.exports = __webpack_public_path__ + "media/bootstrap-icons/markdown-65e57c27.svg";